export const AUTOMATIONS_TAB_OPTIONS = [
  { value: 'attive', label: 'Automazioni Attive' },
  { value: 'suggerite', label: 'Suggerite per Te' },
];

export function getInitialCustomAutomationRequest() {
  return {
    descrizione: '',
    funzionalita: '',
    obiettivo: '',
  };
}
